import React from 'react';
import { titleize, unescapeHTML } from 'underscore.string';
import i18next from 'i18next';

const nameFormatter = (cell) => <span>{unescapeHTML(cell)}</span>;
export const getColumns = () => {
  return [
    {
      dataField: 'order.order_id',
      text: i18next.t('ORDER_ID'),
      entityType: 'order',
      type: 'entity',
      sort: true,
    },
    {
      dataField: 'order.status',
      text: i18next.t('ORDER_STATUS'),
      type: 'status',
      sort: true,
    },
    {
      dataField: 'order.order_type',
      text: i18next.t('ORDER_TYPE'),
      sort: true,
    },
    {
      dataField: 'shipper.status',
      sort: true,
      text: i18next.t('ACCOUNT_STATUS'),
      type: 'service_watch',
    },
    {
      dataField: 'shipper.company_name',
      text: titleize(i18next.t('CUSTOMER')),
      formatter: nameFormatter,
      sort: true,
    },
    {
      dataField: 'exception_type',
      text: i18next.t('TYPE'),
      sort: true,
    },
    {
      dataField: 'release_time',
      type: 'dateWithTime',
      text: i18next.t('CREATED'),
      sort: true,
    },
    {
      dataField: 'reporter',
      text: i18next.t('REPORTER'),
      type: 'reporter',
      sort: true,
    },
  ];
};
